import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';

export function bugsnagInit() {
  Bugsnag.start({
    apiKey: window.BUGSNAG_API_KEY || 'development',
    releaseStage: window.APP_ENV,
    plugins: [new BugsnagPluginReact()],
    enabledReleaseStages: ['production', 'staging'],
    autoTrackSessions: window.APP_ENV !== 'development'
  });
}
